import { render, staticRenderFns } from "./huotiStatisticsDetail.vue?vue&type=template&id=6111c67c&scoped=true&"
import script from "./huotiStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./huotiStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./huotiStatisticsDetail.vue?vue&type=style&index=0&id=6111c67c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6111c67c",
  null
  
)

export default component.exports